import { Link, useLocation } from 'react-router-dom';

export function NotFoundPage() {
  const { search } = useLocation();
  return (
    <section className="panel state-card not-found-state">
      <span className="operations-card-label">Navigation</span>
      <h1>Page not found</h1>
      <p>The requested integration console page does not exist or has moved.</p>
      <div className="panel-actions">
        <Link className="button-link primary-link" to={{ pathname: '/dashboard', search }}>Return to overview</Link>
      </div>
    </section>
  );
}
